module.exports = __webpack_public_path__ + "img/el_menu7.f5b9ff44.png";